package br.com.vvrefeicoes.portal.domain.model

enum class PermissionAction {
    CREATE,
    EDIT,
    VIEW,
}

val allPermissionActions: Set<PermissionAction> = PermissionAction.entries.toSet()

fun Map<String, Set<PermissionAction>>.allows(
    key: String,
    action: PermissionAction,
): Boolean = this[key]?.contains(action) == true

/** Verdadeiro quando o usuário tem a permissão com qualquer ação (CREATE/EDIT/VIEW). */
fun Map<String, Set<PermissionAction>>.allowsAny(key: String): Boolean = this[key]?.isNotEmpty() == true
